module.exports = __webpack_public_path__ + "open-sans-latin-300.3c60d17baaa7a8391013.eot";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-300.eot
// module id = ../../../../typeface-open-sans/files/open-sans-latin-300.eot
// module chunks = 1 3